export enum ButtonTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Ghost = 'ghost',
  Text = 'text',
}
